// extracted by mini-css-extract-plugin
module.exports = {"banner":"Styles_banner__1sjxa","link":"Styles_link__stdou","icon":"Styles_icon__1_XR4","closeButton":"Styles_closeButton__3BMZK"};